import {
  ACTIVATE_API_URL,
  API_DETAILS_URL,
  API_LIST_URL,
  APPROVE_API_URL,
  CREATE_PARTNER_PROPERTY,
  DEACTIVATE_API_URL,
  DOWNLOAD_KEY,
  GET_PARTNER_PROPERTIES,
  REJECT_API_URL,
  UPDATE_FSP_CODE,
  UPDATE_OUTBOUND_CREDENTIALS,
  UPDATE_PARTNER_PROPERTY,
  VIEW_API_URL,
} from "../../constant";
import { resourceRequest } from "../calls";

export function dofetchAllApi(token, data) {
  return resourceRequest(token, API_LIST_URL, data);
}

export function doApiDetails(token, data) {
  return resourceRequest(token, API_DETAILS_URL, data);
}

export function doViewAPi(token, data) {
  return resourceRequest(token, VIEW_API_URL, data);
}

export function doActivateApi(token, data) {
  return resourceRequest(token, ACTIVATE_API_URL, data);
}

export function doDeactivateApi(token, data) {
  return resourceRequest(token, DEACTIVATE_API_URL, data);
}

export function doApproveApi(token, data) {
  return resourceRequest(token, APPROVE_API_URL, data);
}

export function doRejectApi(token, data) {
  return resourceRequest(token, REJECT_API_URL, data);
}

export function doGetPartnerProperties(token, data) {
  return resourceRequest(token, GET_PARTNER_PROPERTIES, data);
}

export function doCreatePartnerProperty(token, data) {
  return resourceRequest(token, CREATE_PARTNER_PROPERTY, data);
}

export function doUpdatePartnerProperty(token, data) {
  return resourceRequest(token, UPDATE_PARTNER_PROPERTY, data);
}

export function doUpdateFspCode(token, data) {
  return resourceRequest(token, UPDATE_FSP_CODE, data);
}

export function doUpdateOutboundCredentials(token, data) {
  return resourceRequest(token, UPDATE_OUTBOUND_CREDENTIALS, data);
}

export function doDownloadKey(token, data) {
  return resourceRequest(token, DOWNLOAD_KEY, data);
}
